<div class="m-1 w-[400px] h-[600px]">
    <div class="flex justify-between">
        <div>
            <label for="lightColor">Select your Theme Color:</label>
            <br>
            <p-colorpicker [(ngModel)]="lightColor" (onChange)="updateTheme()" />
            <input pInputText type="text" name="lightColor" id="lightColorText"
                    [(ngModel)]="lightColor" (change)="updateTheme()" style="max-width: 7rem;" />
            @if (canRestoreLightColor()) {
            <p-button size="small" (click)="restoreLightColor()">
                <fa-icon [icon]="icons.faRotateLeft"></fa-icon>
            </p-button>
            }
        </div>
        <div class="max-w-[50%]">
            <button (click)="restoreDefaultColors()" class="auctionManagerButton">Restore defaults</button>
            @if (message.length > 0) {
                <p-message severity="warn">{{message}}</p-message>
            }
        </div>
    </div>

    <h1 class="my-4 text-[20px]">Preview:</h1>
    <div class="flex flex-col justify-between w-full">

        <div>
            <span>Buttons:</span>
            <div class="m-1 flex justify-between">

                <div class="text-center">
                    <button pButton class="p-button-info !text-[var(--p-text-color-secondary)] flex flex-row relative h-9">
                        <fa-icon [icon]="icons.faShoppingBag" class="text-[16px]"></fa-icon>
                        <span class="text-[16px] block">Items</span>
                    </button>
                </div>

                <div class="text-center">
                    <button pButton class="p-button-info !text-[var(--p-text-color-secondary)] flex flex-col md:flex-row relative h-9">
                        <fa-icon [icon]="icons.faShoppingBag" class="text-[16px]"></fa-icon>
                    </button>
                    <span class="text-[14px] block">Items</span>
                </div>

                <div>
                    <button class="p-button rounded-2xl w-full h-9 px-4">
                        <span class="text-[var(--p-text-color-primary)]">
                            <fa-icon [icon]="icons.faShoppingBag"></fa-icon>
                            View All Items
                        </span>
                    </button>
                </div>

            </div>
        </div>

        <div class="flex">
            <div class="w-[6rem]">
                <span>Icons:</span>
                <div class="flex justify-center">
                    <div class="w-[50px] h-[50px] mr-3 flex-none flex justify-center items-center relative rounded-md">
                        <fa-icon [icon]="icons.faCalendar"
                                class="text-[var(--p-info-500)] text-[28px]"></fa-icon>
                        <div class="h-full w-full bg-[var(--p-primary-500)] opacity-10 absolute"></div>
                    </div>
                </div>
            </div>
            <div>
                <span>Search Bar:</span>
                <div class="w-full flex justify-center px-1">
                    <p-inputgroup class="w-full h-[40px]">
                        <input pInputText
                                placeholder="Item Number or Name"
                                class="pl-3 flex-grow focus:outline-none h-full font-mulish border-2 border-[var(--p-primary-500)] rounded-l-lg box-border" />
                        <p-button label="Search"
                                styleClass="h-full !font-mulish border-2 border-[var(--p-primary-500)] rounded-r-lg !text-[var(--p-text-color-primary)]"
                                [style]="{'background-color': 'var(--p-primary-500)', 'border-color': 'var(--p-primary-500)'}">
                            <ng-template #icon>
                                <fa-icon [icon]="icons.faSearch"></fa-icon>
                            </ng-template>
                        </p-button>
                    </p-inputgroup>
                </div>
            </div>
        </div>
    </div>

    <div>
        <div class="w-full relative">
            <span>Highlighted text:</span>
            <div class="bg-[var(--p-primary-500)] opacity-10 w-full h-full absolute pointer-events-none"></div>
            <div class="w-full h-full p-8">
                <div class="text-[20px] mt-8">
                    <p>Your highlighted text will go here</p>
                </div>
            </div>
        </div>
    </div>
</div>
